import React from 'react';
import '../styles/VideoHub.css';

const VideoHub = () => {
  return (
    <div className="page videohub-page">
      <h1>Video Hub</h1>
      <p>Watch our latest videos, webinars, and tutorials.</p>
    </div>
  );
};

export default VideoHub;
